import React from 'react';
import { AutoResizer } from 'react-base-table';
import { Retry } from '@components/common';
import { useSelector } from 'react-redux';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import { isEmpty } from 'lodash';
import { TableWrapper, StyledBaseTable } from './styled';
import useFetchData from './useFetchData';
import { buildColumns } from './utils';
import TableSkeleton from '@components/overview-dashboard/common/TableSkeleton';
import SortIndicator from './SortIndicator';
import useSetImpactedViewersExport from './useSetImpactedViewersExport';

function Table() {
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const columns: any = buildColumns(currentMetricsMeta);

  const { isIdle, status, rows, refetch, sortBy, onColumnSort } = useFetchData({});

  useSetImpactedViewersExport({ columns, rows });

  return (
    <TableWrapper>
      <Retry
        isLoading={status === 'loading' || isIdle}
        showError={status === 'error'}
        isEmpty={isEmpty(rows)}
        mountChildAlways={false}
        fetchData={refetch}
        LoadingLayer={TableSkeleton}
      >
        <AutoResizer>
          {({ width, height }) => (
            <StyledBaseTable
              data={rows}
              columns={columns}
              headerHeight={50}
              rowHeight={45}
              fixed={false}
              width={width}
              height={height}
              rowKey="VIEWER_ID"
              sortBy={sortBy}
              onColumnSort={onColumnSort}
              components={{
                SortIndicator,
              }}
            />
          )}
        </AutoResizer>
      </Retry>
    </TableWrapper>
  );
}

export default Table;
